import React, {Component } from 'react';
// import Backdrop from '../../Backdrop/Backdrop';
// import Aux from '../../../../containers/hoc/Auxiliary';

import classes from './FlashModal.css';

class FlashModal extends Component {
    shouldComponentUpdate(nextProps, nextState){
        return nextProps.show !== this.props.show
        || nextProps.children !== this.props.children;
    }


    render(){
        return(     
            <div   
                className={classes.FlashModal} 
                style={{
                    transform: this.props.show ? 'translateY(30vh)' : 'translateY(100vh)',
                    opacity: this.props.show ? '1' : '0'
                }}>
                <p className={classes.Text}>{this.props.children}</p>
            </div>
        )
    }
}

export default FlashModal;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/FlashModal/FlashModal.js